import _ from "lodash";
import { BellMessageCardType } from "../views/panel/components/bellMessageCard/BellMessageCard.types.js";
const urlPattern = /^https?:\/\/[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)/;
const expUrlPatten = /^https:\/\/exp.microsoft.com\/*/;
const expPPEUrlPatten = /^https:\/\/ppeui.exp.microsoft.com\/*/;
const expDocsUrlPattern = /^https:\/\/expdocs.azurewebsites.net\/*/;
const expInternalWikiUrlPattern = /^https:\/\/dev.azure.com\/experimentation\/*/;
const entityUrlPatterns = [expUrlPatten, expPPEUrlPatten];
function convertSeverity(severity) {
  const type = (severity - 10) / 10;
  const length = Object.entries(BellMessageCardType).length;
  if (type < 0 || type > length || (severity - 10) % 10 !== 0) {
    return BellMessageCardType.info;
  }
  return type;
}
function convertMessages(messageResults) {
  var _a, _b;
  var messageCardItems = messageResults && _.map((_a = messageResults.Value) == null ? void 0 : _a.Messages, (f) => convertMessage(f)) || [];
  var lastMessageId = ((_b = messageResults == null ? void 0 : messageResults.Value) == null ? void 0 : _b.LastMessageId) || -1;
  return {
    MessageCardItems: messageCardItems,
    LastMessageId: lastMessageId
  };
}
function convertMessage(messageDto) {
  return {
    messageId: messageDto.MessageId,
    sevirity: messageDto.Severity,
    heading: messageDto.Message.NotificationTypeName,
    description: messageDto.Message.BriefMessage,
    time: messageDto.CreateTime,
    linkText: messageDto.Message.LinkText,
    linkValue: messageDto.Message.LinkValue,
    footerButtonText: messageDto.Message.FooterButtonText,
    footerButtonLink: messageDto.Message.FooterButtonLink,
    footerButtonOpenInNewTab: messageDto.Message.FooterButtonOpenInNewTab
  };
}
function validateUrl(path) {
  return urlPattern.test(path) && valideEntityUrl(path);
}
function validateWikiUrl(path) {
  return expUrlPatten.test(path) || expDocsUrlPattern.test(path) || expInternalWikiUrlPattern.test(path);
}
function valideEntityUrl(path) {
  for (let pattern of entityUrlPatterns) {
    if (pattern.test(path)) {
      return true;
    }
  }
  return false;
}
export {
  convertMessages,
  convertSeverity,
  validateUrl,
  validateWikiUrl
};
//# sourceMappingURL=CommonUtil.js.map
